var site = site || {};
site.SellsWithKit = site.SellsWithKit || {};

(function ($) {

if($(".mpp-wrapper").css('background-image') == "none") {
  $(".mpp-wrapper").css("min-height", "0px");
}

site.mpp = {
    categoryData : {},
    categoryFilterMenus : {
      group_1 : ['CAT1573','CAT1667','CAT1675','CAT1687','CAT4034'],
      group_2 : ['CAT1599','CAT1607'],
      group_3 : ['CAT1598'],
      group_4 : ['CAT1597']
    },
    $addLinks : null,
    init : function() {
        // view toggle
        $(".mpp-view-toggle a").on('click', function(e) {
            e.preventDefault();
            site.mpp.closeAnyOpenQuickshop();
            $(".mpp-view-toggle a").toggleClass("active");
            $("ul#mpp-product-grid").toggleClass("view-small").toggleClass("view-large");
            // to re-flow the products
            $('ul#mpp-product-grid li.mpp-box').sort(eval('site.mpp.' + $('.sort.active[data-sort]').attr('data-sort'))).appendTo('ul#mpp-product-grid');
        });

        //view more dropdown
        $('a.sort-more-trigger').on('click', function(e) {
          e.preventDefault();
          if($('ul.sort-more-dropdown').hasClass('hidden')) {
            $('ul.sort-more-dropdown').removeClass('hidden');
          } else {
            $('ul.sort-more-dropdown').addClass('hidden');
          }
        });
        site.mpp.setVisibleItemCount();
        site.mpp.customHeader();
        site.mpp.badge();
        site.mpp.initSort();
        site.mpp.customImgTouts();
        site.mpp.customFooter();
        site.mpp.customGridView();
        setTimeout( function() { site.mpp.initFilter(true); }, 100);
        site.mpp.populateStickyBar();
        if ( Drupal.cl.hasPersonalization() ) {
            site.profile.products.MPP.init(site.mpp.data);
        };
    },
    initSort  : function() {
      $('.mpp-sort-by a[data-sort]').on('click', function(e) {
        e.preventDefault();
        site.mpp.closeAnyOpenQuickshop();
        var sortBy = $(e.target).attr('data-sort');
        if (!$(e.target).hasClass('active')){
          var arr = $('ul#mpp-product-grid li.mpp-box').sort(eval('site.mpp.'+sortBy));
          arr.appendTo('ul#mpp-product-grid');
        }
        $('.mpp-sort-by a[data-sort]').removeClass('active');
        $(e.target).addClass('active');
      });
      // default order
      if (!Drupal.settings.product_display_order) {
         $('ul#mpp-product-grid li.mpp-box').sort(eval('site.mpp.sortByBestNewThenDispOrder')).appendTo('ul#mpp-product-grid');
      }
    },
    sortByCollection  : function(a,b) {
      $('#sort-type').html('Collections').parent().removeClass('hidden');
      return $(a).attr('data-collection') >= $(b).attr('data-collection') ? 1 : -1;
    },
    sortByRated  : function(a,b) {
      $('#sort-type').html('Top Rated').parent().removeClass('hidden');
      return $(a).attr('data-rating') >= $(b).attr('data-rating') ? -1 : 1;
    },
    sortByBestseller  : function(a,b) {
      $('#sort-type').html('Best Sellers').parent().removeClass('hidden');
      return $(a).attr('data-bestseller') >= $(b).attr('data-bestseller') ? 1 : -1;
    },
    sortByNewThenRated  : function(a,b) {
      $('#sort-type').html('New &amp; Top Rated').parent().removeClass('hidden');
      var va = ($(a).attr('data-new') === 'true') ? 10 : $(a).attr('data-rating');
      var vb = ($(b).attr('data-new') === 'true') ? 10 : $(b).attr('data-rating');
      return va >= vb ? -1 : 1;
    },
    sortByBestNewThenDispOrder  : function(a,b) {
      var va = ($(a).attr('data-bestseller') === 'true') ? -2 : ($(a).attr('data-new') === 'true') ? -1 : parseInt('0' + $(a).attr('data-displayorder'));
      var vb = ($(b).attr('data-bestseller') === 'true') ? -2 : ($(b).attr('data-new') === 'true') ? -1 : parseInt('0' + $(b).attr('data-displayorder'));
      return va >= vb ? 1 : -1;
    },
    sortByPrice  : function(a,b) {
      $('#sort-type').html('Price $-$$').parent().removeClass('hidden');
      var a_num = parseFloat($(a).find('p.price').html().replace(/[^\d.-]/g, ''));
      var b_num = parseFloat($(b).find('p.price').html().replace(/[^\d.-]/g, ''));
      return a_num >= b_num ? 1 : -1;
    },
    sortByPriceDesc  : function(a,b) {
      $('#sort-type').html('Price $$-$').parent().removeClass('hidden');
      var a_num = parseFloat($(a).find('p.price').html().replace(/[^\d.-]/g, ''));
      var b_num = parseFloat($(b).find('p.price').html().replace(/[^\d.-]/g, ''));
      return a_num >= b_num ? -1 : 1;
    },
    setVisibleItemCount : function() { //call on init and when filter choices are applied
      $('h1 .item-count').html('('+ $('.mpp-grid li.mpp-box').not('.hidden').length +')');
    },
    initFilter : function(onContentLoad) {

      // collaspe/show filter block
      $('a.btn-filter-expand-collapse').off('click');
      $('a.btn-filter-expand-collapse').on('click', function(e){
        e.preventDefault();
        var $filters = $('.mpp-filter');
        var $this = $(this);
        var base_height = ($('.custom_mpp_subheader').length > 0) ? 125 : 80;
        var h = $filters.hasClass('collapsed') ? 243 : ($this.hasClass("large") ? 135 : base_height);
        $filters.animate({
          height: h
        }, {
          duration: 'slow',
          complete: function() {
            $filters.toggleClass('collapsed');
            if (!$filters.hasClass('collapsed')) {
              $filters.css('height', 'auto');
            }
          }
        });
        $('a.btn-filter-expand-collapse').toggleClass('expanded');
      });

      var concernArr = new Array();
      $('ul#mpp-product-grid li.mpp-box[data-productid]').not('.hidden').each(function(j, prodBox){
        var prodId = $(prodBox).attr('data-productid');
        var product = $(page_data["catalog-mpp"].categories[0].products).filter( function(){
          return this.PRODUCT_ID === prodId;
        })[0];
        if (typeof(product) == "undefined") return true;
        // let's add the skin concerns
        if(product.SKIN_CONCERN != null) {
          for(var i = 0; i < product.SKIN_CONCERN.length; i++){
            if(product.SKIN_CONCERN[i] == null) continue;
            var val = product.SKIN_CONCERN[i].toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
            $(prodBox).addClass(val);
            if(concernArr.indexOf(val) == -1) {
              concernArr.push(val);
            }
          }
        }
        // let's add the skin types
        if(product.SKINTYPE_DESC != null) {
          for(var i = 0; i < product.SKINTYPE_DESC.split(',').length; i++){
            var skinType = product.SKINTYPE_DESC.split(',')[i];
            var val = 'type-' + $.trim(skinType);
            $(prodBox).addClass(val);
            if(concernArr.indexOf(val) == -1) {
              concernArr.push(val);
            }
          }
        }
        // let's add the colour families
        var rb              = generic.rb('language');
        var very_fair       = rb.get("very_fair_family") ? rb.get("very_fair_family") : "very_fair";
        var moderately_fair = rb.get("moderately_fair_family") ? rb.get("moderately_fair_family") : "moderately_fair";
        var moderate        = rb.get("moderate_family") ? rb.get("moderate_family") : "moderate";
        var medium          = rb.get("medium_family") ? rb.get("medium_family") : "medium";
        var deep            = rb.get("deep_family") ? rb.get("deep_family") : "deep";
        for(var i = 0; i < product.skus.length; i++){
          if(product.skus[i].ATTRIBUTE_COLOR_FAMILY !== null){
            var val = $.trim(product.skus[i].ATTRIBUTE_COLOR_FAMILY).toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');

            // fix color mappings
            switch (val) {
              case "natural_browns":
                val = "naturals_browns";
                break;
              case "violets_blues":
                val = "violets_blues";
                break;
              case "violets__blues":
                val = "violets_blues";
                break;
              case "violets___blues":
                val = "violets_blues";
                break;
              case "violets__berries":
                val = "violets_blues";
                break;
              case "violets___berries":
                val = "violets_blues";
                break;
              case very_fair:
                val = "very_fair";
                break;
              case moderately_fair:
                val = "moderately_fair";
                break;
              case moderate:
                val = "moderate";
                break;
              case medium:
                val = "medium";
                break;
              case deep:
                val = "deep";
                break;
            }

            $(prodBox).addClass(val);
            if(concernArr.indexOf(val) == -1) {
              concernArr.push(val);
            }
          }
        }
        // let's add the forms/formats
        var cream_compact = rb.get("cream_compact") ? rb.get("cream_compact") : "cream_compact";
        var liquid_compact = rb.get("liquid_compact") ? rb.get("liquid_compact") : "liquid_compact";
        var powder_compact = rb.get("powder_compact") ? rb.get("powder_compact") : "powder_compact";
        if(product.FORMULA !== null){
          var val = $.trim(product.FORMULA).toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');

          // fix formula mappings
          switch (val) {
            case cream_compact:
              val = "cream";
              break;
            case powder_compact:
              val = "powder";
              break;
            case liquid_compact:
              val = "liquid";
              break;
          }

          $(prodBox).addClass(val);
          if(concernArr.indexOf(val) == -1) {
            concernArr.push(val);
          }
        }
      });

      // now let's activate only applicable filter options
      $('.mpp-filter-content li.filter-item').addClass('inactive');
      for(var i = 0; i < concernArr.length; i++){
        $('.mpp-filter-content li.filter-item.'+concernArr[i]).removeClass('inactive');
      };
      if(onContentLoad) {
        $('.mpp-filter-content .mpp-filter-column1 li.filter-item.inactive').addClass('hidden'); // add hidden class to items who aren't available for this MPP's "default state" (i.e., when no filters are currently engaged)
      }
      // let's bind active filter options
      $('.mpp-filter-content li.filter-item a').unbind();
      $('.mpp-filter-content li.filter-item a').not('li.inactive a').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        site.mpp.filterProducts();
      });
      //let's active filter section and filter group
      for(var key in site.mpp.categoryFilterMenus){
        if((site.mpp.categoryFilterMenus[key].indexOf(window.CATEGORY_ID) != -1)
          && ($('.mpp-filter-content li.filter-item:not(.inactive)').length !== 0)){ // added a check - e.g. 'Serum' is marked as having filters, but none actually apply
          $('a.btn-filter-expand-collapse').removeClass('hidden');
          $('.mpp-filter h2').not('.'+key).addClass('hidden');
          $('.mpp-filter-content li.filter-item').not('.'+key).addClass('hidden');
          // if we only have one filter, promote everything to column1... the other column won't show anyway, so we can do this indiscriminately
          if($('.mpp-filter h2.'+key).length == 1) {
            $('.mpp-filter-column2').addClass('mpp-filter-column1').removeClass('mpp-filter-column2');
          }
        }
      }
      if(onContentLoad) { // change layout "status" if the first column only has a few visible filter list items
        if($('.mpp-filter-content li.filter-item.group_1:not(.hidden)').length === 0) {
          $('.mpp-filter').addClass('fixed-width-items-only');
        } else if($('.mpp-filter-content .mpp-filter-column1 li.filter-item:not(.hidden)').length <= 4) {
          $('.mpp-filter-column1').addClass('narrow');
          $('.mpp-filter-column2').addClass('narrow');
        }
      }
    },
    filterProducts : function() {
      site.mpp.closeAnyOpenQuickshop();
      $('li.mpp-box').addClass('hidden');
      var prods = $('li.mpp-box');
      var activeParams = [];
      // we grab applicable classname filters, but create 'or' class selectors since
      // one filter option may need to encompass multiple concerns or benefits
      $('.mpp-filter-content li.filter-item a.active').each(function(){
        activeParams.push($(this).parent().attr('class'));
      });
      for(var i = 0; i < activeParams.length; i++){
        var selector = 'li.mpp-box.na';
        for(var j = 1; j < activeParams[i].split(' ').length; j++){
          selector += ', li.mpp-box.' + activeParams[i].split(' ')[j];
        }
        // whittle down the matches
        prods = $(prods).filter(selector);
      }
      if(activeParams.length == 0){
        $('li.mpp-box').removeClass('hidden');
      }
      $(prods).removeClass('hidden');
      site.mpp.initFilter();
      site.mpp.setVisibleItemCount();
      site.mpp.populateStickyBar();
    },
    closeAnyOpenQuickshop : function() {
      $('#quickshop .close').trigger('click');
    },
    placeAndDisplayQuickshop: function(out, clickedProduct) {
      //
      // Place Quickshop in the right place.
      //
      var clickedLiIndex = $("li.mpp-box").index(clickedProduct);
      var ulWidth = $("#mpp-product-grid").width();
      var liWidth = $(clickedProduct).width();
      var numProducts = $("li.mpp-box").length;
      var productsPerRow = parseInt(ulWidth/liWidth);
      var numRows = numProducts/productsPerRow;
      if (numRows != parseInt(numRows)) {
        numRows = parseInt(numRows) + 1;
      }
      var rowClicked = parseInt(clickedLiIndex/productsPerRow) + 1;
      if (rowClicked != numRows) {
        var lastProdInClickedRowIndex = (rowClicked * productsPerRow) -1;
      } else {
        var lastProdInClickedRowIndex = $("li.mpp-box").length -1;
      }
      var lastProduct = $("li.mpp-box")[lastProdInClickedRowIndex];

      // Create an LI that will contain the quickshop
      var qsWrapperLi = document.createElement('li');
      var qsProdId = clickedProduct.attr('data-productid');
      $(qsWrapperLi).attr("id", "quickshop-wrapper").attr('data-productid', qsProdId).append(out);
      $(lastProduct).after(qsWrapperLi);

      //
      //  Display Quickshop in nice sliding animation
      //
      var qs = $('#quickshop');
      var bottom_padding = 50;
      var speed = 500;
      var topPositionNavOffset = $('#top').height() + 40;
      qs.slideDown(speed, function(){
        $(document).trigger('sells_with_init', qs);
        var pos = qs.position();
        var window_height = $(window).height();
        var offset = qs.offset();
        var posY = offset.top - $(window).scrollTop();
        var clickedProductOffset = clickedProduct.offset();
        var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
        var qs_bottom_position = posY + $('#quickshop-wrapper').height() + bottom_padding;
        // only scroll page if the quickshop fall within the viewable area
        if (qs_bottom_position > window_height) {
          /**
           * bottom of quickshop isn't visible, so let's formulate both options
          **/
          // option 1: place selected product near top of viewing area
          var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
          // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
          var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
          // select our best option
          var scrollPosition = (quickshop_in_viewport < prod_row) ? prod_row : quickshop_in_viewport;
          // now scroll the window...
          $('body, html').scrollTo(scrollPosition, {duration: speed, axis: "y"});
        }
      });
    },
    badge: function(){
      // loop through all labels
      // if the badge label is empty remove the class that makes the colored circular badge
      $('.badge-inner').each(function() {
        if($(this).html() == ''){
            $(this).parents().removeClass('badge');
          }
      });

      $('.badge_1 .badge-inner').parents('li[data-new]').attr('data-new', 'true');
      $('.badge_30').parents('li[data-bestseller]').attr('data-bestseller', 'true');
    },
    populateStickyBar:  function() {
      var sticky_content = '<h3>' + $('.mpp-wrapper h1').html() + '</h3>';
      var sticky_filters = [];
      $('.filter-item .active').each(function(){
        var filter_col = ($(this).parents('.mpp-filter-column1').length > 0) ? '.mpp-filter-column1' : '.mpp-filter-column2';
        var filter_type = $(filter_col + ' h2[data-shortname]:not(.hidden)').attr('data-shortname');
        var filter_val = $(this).text().replace(' x', '');
        if(typeof(sticky_filters[filter_type]) === 'undefined'){
          sticky_filters[filter_type] = [filter_val];
        } else {
          sticky_filters[filter_type].push(filter_val);
        }
      });
      for (var key in sticky_filters){
        if (typeof sticky_filters[key] !== 'function') {
          var filter_div = '<div class="filter_div"><strong>'+key+'</strong> ';
          $.each(sticky_filters[key], function(index, value){
            filter_div += value + ', ';
          });
          sticky_content += filter_div.substring(0, filter_div.length - 2) + '</div>';
        }
      }
      // 2019 Redesign - check if behavior is real before loading it
      if (typeof Drupal.behaviors.clinique_sticky_bar !== 'undefined') {
        Drupal.behaviors.clinique_sticky_bar.addContent(sticky_content);
      }
    },
    customHeader:  function(){
      if($('.custom_mpp_header').length > 0){
        $('.mpp_cat_header').html($('.custom_mpp_header').html());
      }
      if($('.custom_mpp_subheader').length > 0){
        $('.custom_mpp_subheader').removeClass('hidden').appendTo($('.mpp_cat_subhead'));
        $('.mpp_cat_subhead').removeClass('hidden');
        $('section.mpp-filter.collapsed').css('height', '125px');
      }
    },
    customImgTouts:  function() {
      var $mppProductGrid = $('#mpp-product-grid');
      $mppProductGrid.each(function() {
        var $mppBox = $(this).find('.mpp-box');
        $mppBox.each(function(i) {
          var $self = $(this);
          $self.css({'margin-bottom':'20px'}); // should this go in the SCSS file?
          $self.attr('data-item',i+1);
          $('.mpp-box.custom-tout').css({'padding':'0'});
          $('.custom-tout-img').css({'max-width':$self.css('width'), 'width':$self.css('width')});
          var $customTouts = $('.custom-touts');
          var $customTout = $customTouts.find('.custom-tout');
          // Custom touts CMS fields
          for (var j = 0; j < $customTout.length; j++) {
            // Get CMS fields data
            var $customToutN = $customTouts.find('.custom-tout'+(j+1));
            var $toutPos = $customToutN.find('.tout-pos').text();
            var $toutImage = $customToutN.find('.custom-tout-image').text();
            var $toutURL = $customToutN.find('.tout-url').text();
            var customToutContent;
            var tout;
            // Tout overlay settings
            var $toutLinkText = $customToutN.find('.tout-overlay-css-class');
            var $toutLinkTextClass = $toutLinkText.text();
            var $overlayContent = $customToutN.find('.tout-popup');
            if ($toutImage.length > 0) {
              customToutContent = '<img class="custom-tout-img" src="' + $toutImage + '" alt="" />';
            }
            if ($toutURL.length > 0) {
              if (typeof $toutLinkTextClass != 'undefined') {
                var overlayClass = $toutLinkTextClass + 'tout-' + (j+1);
                tout = '<a class="'+ overlayClass +'" href="'+ $toutURL +'"><li class="mpp-box custom-tout">' + customToutContent + '</li></a>';
              }
              else {
                tout = '<a href="'+ $toutURL +'"><li class="mpp-box custom-tout">' + customToutContent + '</li></a>';
              }
            }
            else {
              tout = '<li class="mpp-box custom-tout">' + customToutContent + '</li>';
            }
            // "Embed" and append image tout to the product grid in a specific position
            $self.filter(function() {
              return $(this).attr('data-item') == $toutPos-1;
            }).after(tout);
            // Launch tout overlay
            $overlayContent.each(function() {
              var $content = $(this);
              if (typeof $content != 'undefined') {
                var $html = $content.html();
                $('.overlay.tout-' + (j+1)).once('overlay-tout').on('click', function(e) {
                  e.preventDefault();
                  generic.overlay.launch({
                    content: $html,
                    includeBackground: true,
                    lockPosition: true,
                    center: true, // one line required set
                    cssClass: 'custom_tout_popover',
                    cssStyle: {
                      width: "100%",
                      height: "auto",
                      //zIndex: 501,
                      overflow: "hidden"
                    }
                  });
                });
              }
            });
            // Close tout overlay if overlay background is clicked
            $('.overlay-background').on('click', function(e) {
              e.preventDefault();
              generic.overlay.hide();
            });
          } // for loop
        });
      });
    },
    customFooter:  function() {
      // Noderef field
      if($('.custom_mpp_footer_noderef').length > 0) {
        $('#mpp-product-grid').after($('.custom_mpp_footer_noderef').html());
      }
      var $nodeRefId = $('.custom_mpp_footer_noderef').find('.node.node-elc-nodeblock').attr('id');
      // Textarea field
      if($('.custom_mpp_footer').length > 0) {
        // Check if a noderef is present and append this before the noderef
        // If no noderef is present append it after the mpp-product-grid
        if (typeof $nodeRefId != 'undefined') {
          $('.mpp-grid').find('#'+$nodeRefId).before($('.custom_mpp_footer').html());
        }
        else {
          $('#mpp-product-grid').after($('.custom_mpp_footer').html());
        }
      }
    },
    customGridView:  function() {
      // Provide the option to choose a 3 columns product grid view. It default to 5 columns
      if($('.clinique-product-mpp-product-layout-view-large-v1').find('.view-3-cols-large').length > 0) {
        $('.mpp-view-options').find('.mpp-view-toggle').find('.view-large').addClass('active');
        $('.mpp-view-options').find('.mpp-view-toggle').find('.view-small').removeClass('active');
        $('.mpp-grid').find('#mpp-product-grid').removeClass('view-small').addClass('view-large');
      }
    }
};


Drupal.behaviors.cliniqueProductMPPV1 = {
  attach: function (context, settings) {
    $('.cl-mpp-product-layout-v1').once(function() {
      site.mpp.data = {
        category : page_data['catalog-mpp'].categories[0]
      };
      site.mpp.init();
    });
  }
};


$(".btn-quickview[data-productid]").once('btn-quickview-button').on('click', function(e) {
  e.preventDefault();

  var clickedProduct = $(this).closest(".mpp-box");
  var qproduct_id = clickedProduct.attr('data-productid');
  var qsize_dd = clickedProduct.attr('data-sizedd');
  var qsWrapper = $('#quickshop-wrapper');

  // Check if QS for this product is already open
  if (qsWrapper.attr('data-productid') == qproduct_id) {
    // Close it
    qsWrapper.find('.close').trigger('click');
    setTimeout(function() {
      qsWrapper.remove();
    }, 400);
  } else {
    // Remove any others
    qsWrapper.remove();

    // Build new QS
    var qproduct = $(page_data["catalog-mpp"].categories[0].products).filter( function(){
      return this.PRODUCT_ID === qproduct_id;
    })[0];
    qproduct['use_size_drop_down'] = qsize_dd ? 1 : 0;
    qproduct.skus = $.grep(qproduct.skus, function(sku) {
      if (clickedProduct.data('formattedPrice') && qproduct['GIFTSET_COMPONENTS']) {
        sku.formattedPrice = clickedProduct.data('formattedPrice');
      }
      return 1;
    });

    var $qs = site.quickshop.render({
      productData: qproduct
    });
    $('li .caret').addClass('hidden');
    $('li[data-productid="'+qproduct.PRODUCT_ID+'"] .caret').removeClass('hidden');
    site.mpp.placeAndDisplayQuickshop($qs, clickedProduct);
  }
});


// refresh with L2 cache
$(document).on('inventory_status_stored', function(){
  // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
  $(page_data["catalog-mpp"].categories[0].products).each(function(i, product){
    var isOrderableSku = $(product.skus).filter(function(){
      if(typeof $(document).data(this.SKU_ID) != 'undefined'){
        return ($(document).data(this.SKU_ID).isOrderable == 1)
              || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3) || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 2) || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 7);
      } else {
        var validInventory = [1,2,3,7];
        return (validInventory.indexOf(this.INVENTORY_STATUS) > -1) ? 1 : 0;
      }
    })[0];
    var isDisplayableSku = $(product.skus).filter(function() {
      var undef;
      var sku = $(document).data(this.SKU_ID);
      return (typeof site.features.spp_displayable_status !== 'undefined'
        && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]));
    })[0];
    if(typeof isOrderableSku == 'undefined' && !isDisplayableSku){
      // remove product - removed completely so the quickshop positioning remains correct
      $('li.mpp-box[data-productid="'+product.PRODUCT_ID+'"]').remove();
    }
  });
  site.mpp.setVisibleItemCount();
});

})(jQuery);
